import { VRProp } from './props.js';

export class VRBoard extends VRProp {
  static boardCount = 1;
  static defaultWidth = 800;

  constructor (vr, scene, options) {
    super(vr, scene, options);

    this.type = 'display_board';
    if (!this.options.scale) {
      this.options.scale = 1;
    }
    super.setType('prop_board');
    if (!this.options.propId) {
      this.options.propId = vr.assets.boards[0].id;
    }
    // this.setPropId(this.options.propId);

    this.count = VRBoard.boardCount;

    this.dropHint = $('<div class="ca-vr_overlay_drophint"></div>');
    this.dropHint.hide();
    this.assetContainer.append(this.dropHint);

    this.displayBoardContainerWidth = 0;
    this.displayBoardContainerHeight = 0;
    this.displayBoardOffsets = {};
    this.type = 'display_board';

    // this.imageSvg = $('<svg class="ca-vr_overlay_imagesvg"><defs><pattern id="img'+this.count+'" patternUnits="objectBoundingBox" width="100%" height="100%" x="50%" y="50%"><image href="" x="0" y="0" /></pattern></defs><path fill="url(#img'+this.count+')" d="M'+dropHintTopLeft.x+','+dropHintTopLeft.y+' L255,90 L255,95 L291,95 L291,90      L'+(dropHintTopRight.x)+','+(dropHintTopRight.y)+' L'+(dropHintBottomRight.x)+','+(dropHintBottomRight.y)+' L'+(dropHintBottomLeft.x)+','+(dropHintBottomLeft.y)+'" /></svg>');
    // this.assetContainer.append(this.imageSvg);

    this.dropHintLabel = $(
      '<div class="ca-vr_overlay_drophint_label"><i class="fa fa-image"></i><br />Drop to update board</div>'
    );
    this.dropHint.append(this.dropHintLabel);

    this.div.on(
      'dragover',
      function (e) {
        e.preventDefault();
      }
    );

    this.div.on(
      'dragenter',
      function (e) {
        e.preventDefault();
        this.showDropHint(true);
      }.bind(this)
    );

    this.div.on(
      'dragleave',
      function (e) {
        e.preventDefault();
        this.showDropHint(false);
      }.bind(this)
    );

    if (!this.options.propType) this.options.propType = 0;

    this.headingContainer = $(
      '<div class="ca-vr_overlay_board_heading-container"></div>'
    );

    this.assetContainer.append(this.headingContainer);

    if (!this.options.propId) {
      this.setAsset(vr.assets.boards[0]);
    } else {
      this.setAsset(this.vr.getBoardAsset(this.options.propId));
    }

    if (!this.options.heading) {
      this.options.heading = {
        text: this.asset.name,
        fontSize: 60
      };
    }

    this.headingBackground = $(
      '<div class="ca-vr_overlay_board_heading-bg"></div>'
    );
    this.headingContainer.append(this.headingBackground);

    this.heading = $(
      '<div class="ca-vr_overlay_board_heading" style="font-size:' +
        this.options.heading.fontSize +
        '">' +
        this.options.heading.text +
        '</div>'
    );
    this.headingBackground.append(this.heading);

    VRBoard.boardCount++;

    if (this.options.heading !== undefined) {
      this.toggleHeading(this.options.heading.isHidden);
    }

    if (options.distance) {
      this.options.distance = options.distance;
    }

    if (this.asset.fixedDistance) {
      this.options.minDistance = this.asset.distance;
      this.options.maxDistance = this.asset.distance;
    }

    this.initBoardImageContainers();
    this.initNightLight();
    if (this.options.images !== undefined && this.options.images.length > 0) {
      this.initMultiBoardImagesOnLoad();
    } else if (this.options.image) {
      this.initBoardImage();
    }
  }

  initBoardImageContainers () {
    if (this.asset !== undefined && this.asset.imageAmount !== undefined) {
      if (this.boardImgContainer) {
        $(this.boardImgContainer).remove();
      }

      this.assetContainer.children('.ca_vr_overlay_boardimg_container').remove();
      this.boardImageContainers = [];
      for (let i = 0; i < this.asset.imageAmount; i++) {
        this.boardImageContainers[i] = $(`<div class="ca-vr_overlay_boardimg_container ca-vr_overlay_boardimg_container_${i}"></div>`);
        this.assetContainer.append(this.boardImageContainers[i]);
      }
    } else {
      if (this.boardImageContainers) {
        this.boardImageContainers.forEach((element) => {
          $(element).remove();
        });
      }
      if (this.boardImgContainer) {
        $(this.boardImgContainer).remove();
      }
      this.assetContainer.children('.ca_vr_overlay_boardimg_container').remove();
      this.boardImgContainer = $(
        '<div class="ca-vr_overlay_boardimg_container"></div>'
      );
      this.assetContainer.append(this.boardImgContainer);
    }
  }

  initNightLight () {
    if (this.asset.hasNightLight) {
      this.boardNightLight = $('<div class="ca-vr_overlay_nightlight"></div>');
      this.boardImgContainer.append(this.boardNightLight);
    }
  }

  initMultiBoardImagesOnLoad () {
    for (let i = 0; i < this.asset.imageAmount; i++) {
      const boardImage = $(`<img class="ca-vr_overlay_boardimg ca-vr_overlay_boardimg_${i}">`);
      boardImage.on(
        'load',
        function () {
          this.aspectRatio =
                  boardImage[0].naturalWidth / boardImage[0].naturalHeight;
          this.refreshAssetWithImage(this.vr.getBoardAsset(this.options.propId));
        }.bind(this)
      );
      boardImage.attr('draggable', false);
      this.boardImageContainers[i].append(boardImage);
      if (this.options.images !== undefined) {
        if (this.options.images[i].url) {
          this.initializeMedia(this.options.images[i].url, this.options.images[i].type, i);
        }

        if (this.options.images[i].scale) {
          this.setImageSize(this.options.images[i].scale * 200, i);
        }

        if (this.options.images[i].width) {
          boardImage.width(this.options.images[i].width);
        }
      }
    }
  }

  initBoardImage (atIndex) {
    if (this.asset !== undefined && this.asset.canDisplayImage) {
      if (this.asset.imageAmount === undefined) {
        this.boardImg = $('<img class="ca-vr_overlay_boardimg" />');
        this.boardImg.on(
          'load',
          function () {
            this.aspectRatio =
              this.boardImg[0].naturalWidth / this.boardImg[0].naturalHeight;
            this.refreshAssetWithImage(this.vr.getBoardAsset(this.options.propId));
          }.bind(this)
        );
        this.boardImg.attr('draggable', false);
        if (this.options.image.url) {
          this.setMedia(this.options.image.url, this.options.image.type);
        }
        if (this.options.image.width) {
          this.boardImg.width(this.options.image.width);
        }
        this.boardImgContainer.append(this.boardImg);
      } else {
        // this should support multiple image boards
        if (atIndex !== undefined) {
          const boardImage = $(`.ca-vr_overlay_boardimg .ca-vr_overlay_boardimg_${atIndex}`);
          if (boardImage.length > 0) {
            boardImage.on(
              'load',
              function () {
                this.aspectRatio =
                    boardImage[0].naturalWidth / boardImage[0].naturalHeight;
                this.refreshAssetWithImage(this.vr.getBoardAsset(this.options.propId));
              }.bind(this)
            );
            boardImage.attr('draggable', false);
            if (this.options.images !== undefined) {
              if (this.options.images[atIndex].scale) {
                this.setImageSize(this.options.images[atIndex].scale * 200, atIndex);
              }
              if (this.options.images[atIndex].width) {
                boardImage.width(this.options.images[atIndex].width);
              }
            }
            this.boardImageContainers[atIndex].append(boardImage);
          } else {
            const newBoardImage = $(`<img class="ca-vr_overlay_boardimg ca-vr_overlay_boardimg_${atIndex}">`);
            newBoardImage.attr('draggable', false);
            this.boardImageContainers[atIndex].append(newBoardImage);
            if (this.options.images !== undefined) {
              if (this.options.images[atIndex].scale) {
                this.setImageSize(this.options.images[atIndex].scale * 200, atIndex);
              }
              if (this.options.images[atIndex].width) {
                newBoardImage.width(this.options.images[atIndex].width);
              }
            }
            newBoardImage.on(
              'load',
              function () {
                this.aspectRatio =
                newBoardImage[0].naturalWidth / newBoardImage[0].naturalHeight;
                this.refreshAssetWithImage(this.vr.getBoardAsset(this.options.propId), atIndex);
              }.bind(this)
            );
          }
          // const boardImage = $(`<img class="ca-vr_overlay_boardimg ca-vr_overlay_boardimg_${atIndex}">`);
        }
      }
    }
  }

  setAsset (asset) {
    this.headingContainer.toggle(asset.allowHeading);
    super.setAsset(asset);
  }

  refreshAssetWithImage (asset, imageIndex) {
    this.displayBoardOffsets = this.getAssetBoardOffsets(asset);
    if (asset.id === 'aframe') {
      this.displayBoardContainerHeight = 800;
      this.displayBoardContainerWidth = 530;
    } else if (asset.id === 'tvstand') {
      this.displayBoardContainerHeight = 840;
      this.displayBoardContainerWidth = 500;
    } else if (asset.id === 'easle') {
      this.displayBoardContainerHeight = 800;
      this.displayBoardContainerWidth = 550;
    } else if (asset.id === 'banner') {
      this.displayBoardContainerHeight = 820;
      this.displayBoardContainerWidth = 460;
    }
    if (asset && this.boardImg) {
      this.boardImg.css(
        'transform',
        `translate(
        ${
          ((this.displayBoardContainerWidth - this.boardImg[0].naturalWidth) / 2) +
          this.displayBoardOffsets.horizontal
        }px,
        ${
          ((this.displayBoardContainerHeight - this.boardImg[0].naturalHeight) /
            2) +
          this.displayBoardOffsets.vertical
        }px) scale(${this.options.scale})`
      );
      // this.boardImg.css("transform", "translate(" + asset.mediaTranslate + ")"); <- left in for reference, as is based off of the asset.json
      this.boardImg.css('transform-origin', 'center');
    } else if (asset && this.boardImageContainers) {
      const boardImage = this.boardImageContainers[imageIndex].children();
      boardImage.css(
        'transform',
        `translate(
          ${
            ((this.displayBoardContainerWidth - boardImage[0].naturalWidth) / 2) +
            this.displayBoardOffsets.horizontal
          }px,
          ${
            ((this.displayBoardContainerHeight - boardImage[0].naturalHeight) /
              2) +
            this.displayBoardOffsets.vertical
          }px) scale(${this.options.scale})`
      );
    }
  }

  // @TODO: find a way of altering the actual Display Board Assets instead of having to do the below
  // the below is necessary to have the correct offsets based off of which Display Board is set.
  // @TODO: another issue is that it looks like the easel asset is not set up properly and is conflicting with the a frame
  getAssetBoardOffsets (asset) {
    const offsetObject = {};
    offsetObject.vertical = 0;
    offsetObject.horizontal = 0;

    if (asset.id === 'aframe') {
      offsetObject.vertical = -75;
      offsetObject.horizontal = -0;
    } else if (asset.id === 'tvstand') {
      offsetObject.vertical = -200;
      offsetObject.horizontal = 0;
    } else if (asset.id === 'easle') {
      offsetObject.vertical = -85;
      offsetObject.horizontal = 0;
    } else if (asset.id === 'banner') {
      offsetObject.vertical = 0;
      offsetObject.horizontal = 0;
    }
    return offsetObject;
  }

  parseImageUrl (image) {
    if (image.includes('media.caapp.com.au')) {
      return image + '?w=600';
    }
    return image;
  }

  initializeMedia (url, type, imageIndex) {
    this.options.images[imageIndex].url = this.parseImageUrl(url);
    if (type !== undefined) {
      this.options.images[imageIndex].type = type;
    }

    if (this.options.images[imageIndex].type !== undefined) {
      if (type === 'image') {
        this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}`);
        // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}`);
      } else {
        this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}?p=thumb`);
        // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}&p=thumb`);
      }
    } else {
      this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}`);
      // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}`);
    }
  }

  setMedia (url, type, imageIndex) {
    if (url === undefined) {
      return;
    }
    if (!this.options.image) {
      this.options.image = {};
    }
    if (imageIndex === undefined) {
      if (this.boardImg === undefined) {
        this.initBoardImage();
      }
      this.options.image.url = this.parseImageUrl(url);
      if (type !== undefined) {
        this.options.image.type = type;
      }
      if (this.options.image.type !== undefined) {
        if (type === 'image') {
          this.boardImg.attr('src', `${this.options.image.url}`);
        } else {
          this.boardImg.attr('src', `${this.options.image.url}?p=thumb`);
        }
      } else {
        this.boardImg.attr('src', `${this.options.image.url}`);
      }

      // removed set media align ment
    } else {
      if (!this.options.images) {
        this.options.images = [
          {
            url: '',
            type: ''
          },
          {
            url: '',
            type: ''
          },
          {
            url: '',
            type: ''
          },
          {
            url: '',
            type: ''
          }
        ];
      }
      this.initBoardImage(imageIndex);
      this.options.images[imageIndex].url = this.parseImageUrl(url);
      if (type !== undefined) {
        this.options.images[imageIndex].type = type;
      }

      if (this.options.images[imageIndex].type !== undefined) {
        if (type === 'image') {
          this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}`);
          // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}`);
        } else {
          this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}?p=thumb`);
          // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}&p=thumb`);
        }
      } else {
        this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg').attr('src', `${this.options.images[imageIndex].url}`);
        // this.boardImages[imageIndex].attr('src', `${this.options.images[imageIndex].url}`);
      }
    }
  }

  // @TODO: future task is to refactor this function into a positional change input (move left, up, right, down)
  setMediaAlignment () {
    // this.boardImg.css("margin-left", "50%");
    // this.boardImg.css("margin-top", "50%");
    // this.boardImg.css('transform', 'translate(-50%, -25%)');
    // if(this.options.image.offsetX) this.boardImg.css('margin-left', this.options.image.offsetX);
    // if(this.options.image.offsetY) this.boardImg.css('margin-top', this.options.image.offsetY);
  }

  setImageSize (width, imageIndex) {
    if (imageIndex !== undefined) {
      const currentImageToAdjust = this.boardImageContainers[imageIndex].children('.ca-vr_overlay_boardimg');
      const imageOffsetX = imageIndex === 0 ? -270 : imageIndex === 1 ? 520 : imageIndex === 2 ? 324 : imageIndex === 3 ? 712 : 0;
      const imageOffsetY = imageIndex === 0 ? -470 : imageIndex === 1 ? -587 : imageIndex === 2 ? -453 : imageIndex === 3 ? -477 : 0;
      currentImageToAdjust.css('transform', `rotateX(50deg) translate(${imageOffsetX}px, ${imageOffsetY}px) scale(${width / 200})`);
      this.options.images[imageIndex].scale = width / 200;
    } else {
      this.boardImg.css(
        'transform',
        `translate(
        ${
          ((this.displayBoardContainerWidth - this.boardImg[0].naturalWidth) / 2) +
          this.displayBoardOffsets.horizontal
        }px,
        ${
          ((this.displayBoardContainerHeight - this.boardImg[0].naturalHeight) /
            2) +
          this.displayBoardOffsets.vertical
        }px)
      scale(${width / 200})`
      );
      this.options.scale = width / 200;
    }
  }

  showDropHint (show) {
    console.log('showDropHint: ' + show);

    /* if(show)
        {
            this.dropHint.show();
            this.imageSvg.find('path').attr('fill', '#4474e059');
        }
        else
        {
            this.dropHint.hide();
            this.imageSvg.find('path').attr('fill', 'url(#img'+this.count+')');
        } */
  }

  setPropId (propId) {
    super.setPropId(propId);
    this.setImage(
      this.scene.parseMediaUrl(
        'https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/boards/board_' +
          propId +
          '_{daynight}.png'
      )
    );
    if (this.boardImg !== undefined) {
      if (!this.asset.canDisplayImage || (this.asset.canDisplayImage && !this.options.image)) {
        this.boardImg.css('display', 'none');
        this.boardImgContainer.css('background-color', 'transparent');
      } else {
        this.boardImg.css('display', 'inline');
        this.boardImgContainer.css('background-color', 'white');
      }
    }
    // probably need to set distance here
    if (propId === 'maptable') {
      this.updateTransform(20);
    }
  }

  setHeading (heading) {
    this.heading = heading;
    this.heading.text(heading.text);
  }

  setHeadingText (headingText) {
    this.options.heading.text = headingText;
    this.headingText = headingText;
    this.heading.html(headingText);
  }

  getHeadingText () {
    return this.options.heading.text;
  }

  toggleHeading (isHeadingHidden) {
    if (isHeadingHidden) {
      this.headingContainer.addClass('hidden');
      this.options.heading.isHidden = true;
    } else {
      this.headingContainer.removeClass('hidden');
      this.options.heading.isHidden = false;
    }
  }

  isHeadingHidden () {
    return this.options.heading.isHidden;
  }
}
